export default "/_next/static/images/d3997603884e0b88a973f723059fd243.jpg";